import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { fetchInitialData3 } from "../fetchData";
import Right from '../right/Right';
import withLocation from "../../withLocation";
import Service from '../service/Service';
import './Expert.css';


const service = new Service();

class ExpertMemories extends Component {
    constructor(props) {
        super(props);
        let initialData = {};
        let serverSideData = {};
        let expertMemoriesArr = {};
        let myActionData = {};
        let myLikeMemory=[];
        let myCommentMemory=[];
        let authData = '';
        let firstname='';
        let userPhoto='';
        let userId='';
        let expertActionData='';
        let totalMemory= 0;
        

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];

            console.log("serverSideData ===>", serverSideData)
            expertMemoriesArr = serverSideData['data1']?.result;
            expertActionData = serverSideData['data3']?.ActionDataCount[0];
            totalMemory = expertActionData?.memory_count;

            if(serverSideData['data2'].msg == 1){
              myActionData = serverSideData['data2']?.ActionData[0];
            }else{
              myActionData = [];
            }
            
            myLikeMemory = Array.isArray(myActionData?.memory_like) ? myActionData.memory_like : [];
            myCommentMemory = Array.isArray(myActionData?.memory_comment) ? myActionData.memory_comment : [];
            authData = window.__initialData__["authData"];

            // firstname = authData?.childData?.UserMaster?.firstname || "";
            // userId = authData?.childData?.UserMaster?.UserID;
            // userPhoto = authData?.childData?.UserMaster?.userPhoto;

            firstname = global?.userAry?.childData?.UserMaster?.firstname || "";
            userId = global?.userAry?.childData?.UserMaster?.UserID;
            userPhoto = global?.userAry?.childData?.UserMaster?.userPhoto;

            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }

        this.state = {
          expertMemoriesArr : expertMemoriesArr,
          myActionData: myActionData,
          myLikeMemory: myLikeMemory,
          myCommentMemory: myCommentMemory,
          auth_Data: global?.userAry || authData,
          firstname: firstname,
          userPhoto: userPhoto,
          userId:userId,
          likedUsers: [],
          totalLikes: 0,
          likePageNo: 1,
          lastEvent: 1,
          showLikesOverlay: false,
          selectedMemoryId:null,
          pageSize:10,
          currentPage: 1,
          totalPages: totalMemory,
          isDesktop: null,
          isSticky: true
        }
    }

    // getmymemories
    static initialAction(reqUrl, ftk, authData, uId, childData) {

        const urlParts = reqUrl.split('/');
        const userId = urlParts[urlParts.length - 1];

        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }

        let obj1 = {
            url: global.api_url + "getmymemories",
            body: JSON.stringify({
                "creatorId":userId,
                "pageSize": 10,
                "pageNo": 1
            })
        };

        let obj2 = {
            url: global.api_url + "getUserActions",
            body: service.getUserActionPayload(childData, authData['mycid'])
        };

        let obj3 = {
            url: global.api_url + "getUserActionsCount",
            body: JSON.stringify({
                "user_id": userId
            })
        };

        // return fetchInitialData2(obj1, obj2, JSON.stringify(header));
        return fetchInitialData3(obj1, obj2, obj3, JSON.stringify(header));
    }



    componentDidMount() {

      const path = window.location.pathname;
      const lastPart = path.split('/').pop();

      const expertId = lastPart;
      this.setState({ expertId: expertId });
      this.updateDeviceType();
      document.addEventListener("click", this.domclick);
      window.addEventListener("scroll", this.handleScroll);

    }

    componentWillUnmount() {
      document.removeEventListener("click", this.domclick);
      window.removeEventListener('resize', this.updateDeviceType);
      window.removeEventListener("scroll", this.handleScroll);
    }

    domclick=(e)=>{
      if (!e.target.closest('.report-wrap')) {
        this.setState({ showReportId: null });
      }
    }

    updateDeviceType = () => {
        const isDesktop = window.innerWidth >= 768;
        if (this.state.isDesktop !== isDesktop) {
            this.setState({ isDesktop });
        }
    }

    handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > this.lastScrollY) {
        // scrolling DOWN → remove sticky
        this.setState({ isSticky: false });
      } else {
        // scrolling UP → add sticky
        this.setState({ isSticky: true });
      }

      this.lastScrollY = currentScrollY;
    };

    componentDidUpdate(prevProps, prevState) {
      
      if (prevState.showLikesOverlay !== this.state.showLikesOverlay) {
        if (this.state.showLikesOverlay) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = "auto";
        }
      }
    }

    saveLikeAction=(memId,status)=>{
       
        if(!global.ftk){
          service.showAlert("Please Login");
          window.location.href = global.loginUrl + '?URL=' + global.currentURL;
          return false;
        }else{

          var userInfo = this.state.auth_Data.childData.UserChildList[0];

          let childinfoArr = [];
          if (Array.isArray(userInfo)) {
              childinfoArr = userInfo.map(child => ({
                  childId: child.ChildId || child.childId,
                  childName: child.ChildName || child.childName,
                  dob: child.DOB || child.dob,
                  gender: child.Gender || child.gender ||"",
                  childPic: child.childPhoto || child.childPhoto
              }));
          } else if (userInfo) {
              childinfoArr = [{
                  childId: userInfo.ChildId || userInfo.childId,
                  childName: userInfo.ChildName || userInfo.childName,
                  dob: userInfo.DOB || userInfo.dob,
                  gender: userInfo.Gender || userInfo.gender||"",
                  childPic: userInfo.childPhoto || userInfo.childPhoto
              }];
          }

          let gender = '0'
          if(this.state.auth_Data?.gender == "Boy"){
              gender = '0';
          } else if(this.state.auth_Data?.gender == "Girl"){
              gender = '1';
          } else if(this.state.auth_Data?.gender == "Guardian"){
              gender = '2';
          }

          const url = global.api_ci_url + "api/fetchfromCI/likepost"; //likepost
          const payload = {
              memoryId: memId,
              postType: "0",
              status: status,
              userName: this.state.firstname,
              userGender: gender,
              childArr: childinfoArr
          };

          service.postServiceCall(url, payload)
          .then((json) => {
              if (json?.msg == "1") {
                this.setState((prevState) => {
                  const isLiked = prevState.myLikeMemory?.includes(memId);
                  // Update myLikeMemory array
                  let updatedLikes = Array.isArray(prevState.myLikeMemory)
                      ? [...prevState.myLikeMemory]
                      : [];
                  if (status === "1" && !isLiked) {
                      updatedLikes.push(memId);
                  } else if (status === "0" && isLiked) {
                      updatedLikes = updatedLikes.filter(id => id !== memId);
                  }
                  // Update likeCount in memories array
                  const updatedMemories = prevState.expertMemoriesArr.map(memory => {
                      if (memory.memoryId === memId) {
                          return {
                              ...memory,
                              likeCount: status === "1"
                                  ? (memory.likeCount || 0) + 1
                                  : Math.max((memory.likeCount || 1) - 1, 0)
                          };
                      }
                      return memory;
                  });

                  return {
                      myLikeMemory: updatedLikes,
                      expertMemoriesArr: updatedMemories
                  };
                });
              } else {
                  console.error("Failed to toggle like:", json);
              }
              service.hideLoader();
          })
          .catch((error) => {
              console.error("Error toggling like:", error);
              service.hideLoader();
          });
        }
    }

    closeCommentModal = () => {
      this.setState({ showCommentModal: false, selectedMemoryId: null });
    };

    closeLikedUserPopup = () => {
      this.setState({ showLikesOverlay: false });
    }
    
    openCommentBox = (memoryId) => {
      this.setState({ showCommentModal: true, selectedMemoryId: memoryId });
    }

    showUserLikes = (memoryId) => {
      // showLikeModal
   
      let postData = {
        "pageno": 1,
        "pagesize": 15,
        "memoryId": memoryId,
        "postType": 0,
        "commentId": '',
        "replyId": '',
      }

      const url = global.api_ci_url + "api/fetchfromCI/getmemorylikesparenting";

      service.postServiceCall(url, postData)
        .then((json) => {
          console.log("Get Memory Likes Response:", json);
          if (json?.msg == "1") {
            this.setState({
              likedUsers: json.result || [],
              likePageNo: 2,
              lastEvent: 2,
              totalLikes: json.result?.length || 0,
              showLikesOverlay: true
            });

          } else {
            
          }
          service.hideLoader();
        })
        .catch((error) => {
          console.error("Error getting memory comments:", error);
          service.hideLoader();
        });

    }

    getUserPic = (value, userDesc) => {
      if (value.userpic && value.userpic !== "undefined") {
        return value.userpic;
      }

      if (
        value.userGender === '0' ||
        value.userGender?.toLowerCase() === 'male' ||
        userDesc?.includes('Father')
      ) {
        return 'http://cdn.fcglcdn.com/brainbees/parenting/img/m/father_profile.png';
      }

      if (
        value.userGender === '1' ||
        value.userGender?.toLowerCase() === 'female' ||
        userDesc?.includes('Mom')
      ) {
        return 'http://cdn.fcglcdn.com/brainbees/parenting/img/m/mother_profile.png';
      }

      return 'http://cdn.fcglcdn.com/brainbees/parenting/img/m/father_profile.png';
    };

    addComment = () => {

      var childinfo = this.state.auth_Data.childData.UserChildList[0];

      let childinfoArr = [];
      if (Array.isArray(childinfo)) {
        childinfoArr = childinfo.map(child => ({
          childId: child.ChildId || child.childId,
          childName: child.ChildName || child.childName,
          dob: child.DOB || child.dob,
          gender: child.Gender || child.gender,
          childPic: child.childPhoto || child.childPhoto
        }));
      } else if (childinfo) {
        childinfoArr = [{
          childId: childinfo.ChildId || childinfo.childId,
          childName: childinfo.ChildName || childinfo.childName,
          dob: childinfo.DOB || childinfo.dob,
          gender: childinfo.Gender || childinfo.gender,
          childPic: childinfo.childPhoto || childinfo.childPhoto
        }];
      }

      const commentText = document.getElementById("postcomment").value;
      console.log('----------commentText-',commentText);
      const captchaResponseToken = ""; // Set this if you integrate reCAPTCHA
      let gender = '0'
      if(this.state.auth_Data?.gender == "Boy"){
        gender = '0';
      } else if(this.state.auth_Data?.gender == "Girl"){
        gender = '1';
      } else if(this.state.auth_Data?.gender == "Guardian"){
        gender = '2';
      }
      
      const payload = {
        userType: gender,
        memoryId: this.state.selectedMemoryId,
        comment: commentText,
        userPic: this.state.userPhoto,
        userName: this.state.firstname,
        userId: this.state.userId,
        userGender: gender,
        childArr: childinfoArr[0],
        postType: 1,
        captchaResponseToken: captchaResponseToken
      };

      console.log("Comment Payload:", payload);
      const url = global.api_ci_url + "api/fetchfromCI/postcomment";

      service.postServiceCall(url, payload)
        .then((json) => {
          console.log("Comment Response:", json);
          if (json?.msg == "1") {
            console.log("Comment posted successfully:", json);
            const newComment = {
              userName: this.state.firstname,
              comment: commentText,
              isSticker: 0
            };
            // Optionally, you can update the state to reflect the new comment
            // For example, you might want to fetch the updated comments for the memory
            this.closeCommentModal();
            this.setState(prevState => {
              const updatedMemories = prevState.expertMemoriesArr.map(memory => {
                if (memory.memoryId === this.state.selectedMemoryId) {
                  let updatedComments = Array.isArray(memory.comments)
                    ? [newComment, ...memory.comments]
                    : [newComment];
                  return {
                    ...memory,
                    commentCount: (memory.commentCount || 0) + 1,
                    comments: updatedComments
                  };
                }
                return memory;
              });

              let updatedCommentMemory = prevState.myCommentMemory.includes(this.state.selectedMemoryId)
                ? prevState.myCommentMemory
                : [...prevState.myCommentMemory, this.state.selectedMemoryId];

                console.log('--------------updatedCommentMemory', updatedCommentMemory);
                console.log('----------updatedMemories',updatedMemories);

              return { 
                  expertMemoriesArr: updatedMemories,
                  myCommentMemory: updatedCommentMemory 
               };
            });
          } else {
            console.error("Failed to post comment:", json);
          }
          service.hideLoader();
        })
        .catch((error) => {
          console.error("Error fetching Discussions:", error);
          service.hideLoader();
        });
    }

    renderLikes = () => {
      const { likedUsers } = this.state;
      const { loginUserId, loginUserDesc, memoryId } = this.props;

      return likedUsers.map((value) => {
        let userDesc = value.userDesc || '';
        if (!userDesc && loginUserId === value.likeCreaterid) {
          userDesc = loginUserDesc;
        }

        const userName = value.userName || '';
        const userPic = this.getUserPic(value, userDesc);
        const isMyself = value.is_myself;
        const isFollowing = value.is_following;
        const likeId = value.likeId;
        const likeCreaterid = value.likeCreaterid;

        return (
          <div className="like-row like-row-expert clearfix" key={likeId}>
            <div className="like-user-dp">
              <img src={userPic} alt={userName} />
            </div>

            <div className="like-user-desc">
              <span className="M14_42 uname">{userName}</span>
              <span className="R13_9e udesc">{userDesc}</span>
            </div>

            {!isMyself && (
              <div className="follow_btn_expert">
                <span
                  className={`like-follow isfollow_${likeId}`}
                  data-id={`${memoryId}@${likeCreaterid}@${likeId}`}
                  style={{
                    color: isFollowing ? '#ef3e77' : '#9e9e9e',
                    border:'1px solid #9e9e9e' 
                  }}
                >
                  {isFollowing ? 'Following' : 'Follow'}
                </span>
              </div>
            )}
          </div>
        );
      });
    };

    uploadMemory =()=>{
      const url = `/memories/memoriesupload`;
      window.location.href = service.getRedirectUrl(url);
    }

    handlePageChange = (pageNumber)=>{
      service.showLoader();

      this.setState({ currentPage: pageNumber });

      let postData = {
        creatorId: this.state.expertId,
        childId: '',
        receivedIds: '',
        pageNo: pageNumber,
        pageSize: 10
      };

      const url = global.api_ci_url + "api/fetchfromCI/getmymemories";
      // getmymemories
      service.postServiceCall(url, postData)
        .then((json) => {
          // console.log('--------------json----', json);
          if (json?.msg == "1") {
            const memories = json.result || [];
            // const totalMemories = json.count || 0;
            this.setState({expertMemoriesArr : memories });
            // this.setState({ totalPages: totalMemories });
            window.scrollTo({ top: 0, behavior: 'smooth' });
            service.hideLoader();
          } else {
            console.warn("No data found");
            this.setState({ expertMemoriesArr: [] });
          }
          service.hideLoader();
        })
        .catch((error) => {
          console.error("-----2", error);
          service.hideLoader();
        });


    }

    openReportAbuse =(memoryId,e)=>{

      // console.log('----memory id', memoryId);
      this.setState((prevState) => ({
        showReportId: prevState.showReportId === memoryId ? null : memoryId
      }));

    }

    handleReportClick =(memoryId)=>{
      this.setState({ showReportId: null });

      if(this.state.auth_Data.ftk == ''){
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
      }else{

        var childinfo = this.state.auth_Data.childData.UserChildList[1];

        let childinfoArr = [];
        if (Array.isArray(childinfo)) {
          childinfoArr = childinfo.map(child => ({
            childId: child.ChildId || child.childId,
            childName: child.ChildName || child.childName,
            dob: child.DOB || child.dob,
            gender: child.Gender || child.gender,
            childPic: child.childPhoto || child.childPhoto
          }));
        } else if (childinfo) {
          childinfoArr = [{
            childId: childinfo.ChildId || childinfo.childId,
            childName: childinfo.ChildName || childinfo.childName,
            dob: childinfo.DOB || childinfo.dob,
            gender: childinfo.Gender || childinfo.gender,
            childPic: childinfo.childPhoto || childinfo.childPhoto
          }];
        } 

        // console.log('-------------childinfoArr', childinfoArr);

        let gender = '0'
        if(this.state.auth_Data?.gender == "Boy"){
          gender = '0';
        } else if(this.state.auth_Data?.gender == "Girl"){
          gender = '1';
        } else if(this.state.auth_Data?.gender == "Guardian"){
          gender = '2';
        }

        let payload ={
          "memoryId": memoryId,
          "postType": "0",
          "reqReplyId":"",
          "commentId":"",
          "userPic":this.state.userPhoto,
          "userName":this.state.firstname,
          "userId":this.state.userId,
          "userGender":gender,
          "childArr":childinfoArr,
          "status":"1"
        }

        let url = global.api_ci_url + "api/fetchfromCI/abusepost";

        service.postServiceCall(url, payload)
          .then((json) => {
            
            service.hideLoader();
          })
          .catch((error) => {
            console.error("Error fetching:", error);
            service.hideLoader();
          });

      }


    }
   
    render() {
       
      return (
        <main className="main-container qa-container">
          <Helmet>
              <title>Expert Panel</title>
              <meta name="description" content="Browse our list of experts in various fields." />
          </Helmet>
          <div className="title expert_title">
              <div className="breadcrumb R11_9e">
                  <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                  <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                  <span><a href={service.getRedirectUrl("/experts")} className="R11_9e">Expert Panel</a></span>
                  <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                  <span>Expert Memories</span>
              </div>
              <h1 className="B24_00">Expert Memories</h1>
          </div>
          
          <div className="sub-container left">
            <div className="questionLeftNew">
              <div className="milestone-list">
                {this.state.expertMemoriesArr && this.state.expertMemoriesArr.length > 0 ? (
                  this.state.expertMemoriesArr.map((memory) => {
                    const firstComment = memory.comments && memory.comments.length > 0 ? memory.comments[0] : null;
                    return (
                      <div key={memory.memoryId} className={`memory-tile memory_${memory.memoryId}`} >
                        {/* ===== USER DETAILS ===== */}
                        <div className="memory_user_details">
                          <a href={`/user-profile/${memory.memoryCreatorId}`}>
                            <div className="user-dp">
                              <img src={memory.userPic} onError={(e) => { e.target.src = "//cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png";}} alt="user" />
                            </div>

                            <div className="user-info">
                              <span className="user-name M14_42">
                                {memory.userName}
                              </span>
                              <span className="user-desc R13_9e">
                                {memory.userDesc}
                              </span>
                            </div>
                          </a>

                          <div className="user_right_info">
                            <span className="user-post-time R13_9e">
                              {memory.postDateTime}
                            </span>
                          </div>

                          {memory.memoryCaption && (
                            <span className="user-caption M17_42">
                              {memory.memoryCaption}
                            </span>
                          )}
                        </div>

                        {/* ===== IMAGE ===== */}
                        <div className="post-pic">
                          <img src={memory.memoryImage} width={memory.imageWidth} height={memory.imageHeight} alt="memory" />
                          {memory.isMemoryRejected === 1 && (
                            <div className="post-pic-rejected">
                              <div className="div-text">
                                <p className="txt1">Rejected by Moderator</p>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* ===== ACTIONS ===== */}
                        <div className={`post-options  a_${this.state.isDesktop}`}>
                          <div className="fl-lft">
                            <a href="#" data-icon-font="T" 
                                className={`icon likeIcon likeIconCls_${memory.memoryId} ${this.state.myLikeMemory.includes(memory.memoryId) ? "active-like" : ""}`} 
                                onClick={(e) => { e.preventDefault(); 
                                    if (!this.state.myLikeMemory.includes(memory.memoryId)) {
                                        this.saveLikeAction(memory.memoryId, "1");
                                    }else{
                                        this.saveLikeAction(memory.memoryId, "0");
                                    }
                                }}
                                data-id={memory.memoryId} ></a>

                            <a data-icon-font="" href="#" 
                              className={`icon commentRe ${this.state.myCommentMemory.includes(memory.memoryId) ? "active-like" : ""}`}
                                onClick={(e)=>{e.preventDefault(); this.openCommentBox(memory.memoryId); }}
                            ></a>
                          </div>

                          <div className="fl-rght report-wrap" style={{ display: 'block' }}>
                            <span 
                              onClick={(e) => this.openReportAbuse(memory.memoryId,e)}
                              data-icon-font="&#xe002;"
                              className={`icon report-link report-linkfont abusemem_${memory.memoryId}`}
                              data-id={memory.memoryId}
                            ></span>
                            {this.state.showReportId == memory.memoryId && 
                              <div className={`report-abuse memoryabuse post-abuse_${memory.memoryId}`} 
                                onClick={() => this.handleReportClick(memory.memoryId)}
                                data-id={memory.memoryId} >
                                <span>
                                  Report Abuse
                                </span>
                              </div>
                            }
                          </div>


                        </div>

                        {/* ===== LIKE + COMMENT COUNT ===== */}
                        <div className="post-likes">
                            {memory.likeCount > 0 && (
                            <div className={`div1like likepost_${memory.memoryId}`} onClick={() => this.showUserLikes(memory.memoryId)} >
                                <p className="likes-count R13_9e">
                                <span>{memory.likeCount}</span> Likes
                                </p>
                            </div>
                            )}
                            {memory.commentCount > 0 && (
                            <div className={`div2comment commentpost_${memory.memoryId}`}>
                                <p className="comments-count R13_9e">
                                <a href={`/memories/memoriescomments?memoryId=${memory.memoryId}`} >
                                    <span>{memory.commentCount}</span> Comments
                                </a>
                                </p>
                            </div>
                            )}
                        </div>

                        {/* ===== FIRST COMMENT PREVIEW ===== */}
                        {firstComment && (
                          <div className={`posted_comment post-comment-wrap_${memory.memoryId}`} >
                            <a href={`/memories/memoriescomments?memoryId=${memory.memoryId}`} >
                              <div className="post-comment">
                                <span className="M14_42">
                                  {firstComment.userName}
                                </span>
                                <div className="R14_42 comment-add">
                                  {firstComment.isSticker == 1 ? (
                                    <img className="sticker-comment" src={firstComment.comment} alt="sticker" />
                                  ) : (
                                    firstComment.comment
                                  )}
                                </div>
                                
                              </div>
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div className="submit_first_blog_container no_memory">
                      <div className="icon_container">
                          <span className="submit_blog_icon" data-icon-font="`"></span>
                      </div>
                      <div className="submit_data_container">
                          <span className="M14_9e">Sorry, no memories uploaded.</span>
                      </div>
                  </div>
                )}

                <div className="pagination-sec">
                  <div className="page-nav td-pb-padding-side memories-pagination">
                    {this.state.totalPages > 10 && (
                      <>
                        {/* Previous Button */}
                        {/* {Math.ceil(this.state.totalPages / this.state.pageSize) > 5 && ( */}
                        {this.state.currentPage > 3 && (
                          <span
                            className={`pagination-btn prev-btn ${
                              this.state.currentPage === 1 ? 'disabled' : ''
                            }`}
                            onClick={() =>
                              this.state.currentPage > 1 &&
                              this.handlePageChange(this.state.currentPage - 1)
                            }
                          >
                            <div data-icon-font="k" className="icon share-icon"></div>
                          </span>
                        )}


                        {(() => {
                          const totalPages = Math.ceil(this.state.totalPages / this.state.pageSize);
                          const { currentPage } = this.state;
                          const maxVisible = 5;
                          let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                          let endPage = startPage + maxVisible - 1;

                          if (endPage > totalPages) {
                            endPage = totalPages;
                            startPage = Math.max(1, endPage - maxVisible + 1);
                          }

                          const visiblePages = [];
                          for (let i = startPage; i <= endPage; i++) {
                            visiblePages.push(i);
                          }

                          
                          return visiblePages.map((page) => (
                            <span
                              key={page}
                              className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                              onClick={() => this.handlePageChange(page)}
                            >
                              {page}
                            </span>
                          ));

                        })()}

                        {/* Next Button */}
                        {Math.ceil(this.state.totalPages / this.state.pageSize) > 5 && (
                          <span
                            className={`pagination-btn next-btn${this.state.currentPage === Math.ceil(this.state.totalPages / this.state.pageSize) ? ' disabled' : ''}`}
                            onClick={() =>
                              this.state.currentPage < Math.ceil(this.state.totalPages / this.state.pageSize) &&
                              this.handlePageChange(this.state.currentPage + 1)
                            }
                          >
                            <div data-icon-font="l" className="icon share-icon"></div>
                          </span>
                        )}
                      </>
                    )}
                  </div>
                </div>

                {this.state.isDesktop ? (
                  <div className="desktop-btn askB_1" onClick={() => { window.location.href = "/memories/memoriesupload/"; }}>
                      <span data-icon-font="&#xe000;" className="icon"></span>
                      <span className="M14_white">Upload Your Photo</span>
                  </div>
                ) : (
                  <div className={`snackbar ask-parenting-question ${ this.state.isSticky ? "sticky" : "" }`}
                    onClick={() => {window.location.href = "/memories/memoriesupload/";}}>
                    <div data-icon-font="&#xe000;" className="icon pencil"></div>
                    <span className="B14_white ask-quen">Upload Your Photo</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <Right url={this.props.location.pathname} />

          {this.state.showCommentModal && (
            <div className="addReply-overlay">
              <form id="commentadd" method="POST" className="form-horizontal" encType="multipart/form-data" >
                <div className="addReply-popup ">
                  <div className="popup-header">
                    <span className="icon addReplyClose fl-lft" data-icon-font="s" onClick={this.closeCommentModal} ></span>
                    <span className="M18_48">Add a Comment</span>
                  </div>

                  <div className="addReply-wrap clearfix">
                    <textarea placeholder="Write Your Comment Here" id="postcomment" name="postcomment"></textarea>

                    <a href="#" className="post-btn M14_white" onClick={(e) => { e.preventDefault(); this.addComment(); }}> 
                      POST&nbsp;
                      <span className="icon replyIcon" data-icon-font="&#xe00d;" ></span>
                    </a>
                  </div>

                </div>
              </form>
            </div>
          )}

          {this.state.showLikesOverlay && (
            <div className="likes-overlay left">
              <div className="likes-popup likes-popupfavnames">
                  <div className="popup-header" style={{float: "unset"}}>
                      <span className="icon likesClose fl-lft" data-icon-font="s" onClick={(e) => this.closeLikedUserPopup(e)}></span>
                      <span className="M18_48">Likes</span>
                  </div>
                  <div className="likes-wrap">
                    {this.renderLikes()}
                  </div>
              </div>
            </div>
          )}
        </main>
      );
    }

}

export default withLocation (ExpertMemories);

